import React from 'react'
import Header from '../Header/Header'
import CategoriasData from '../../components/Admin/CategoriasData/CategoriasData'
import HeaderDash from '../../components/Admin/HeaderDash/HeaderDash'
export default function Categorias({ logo }) {
    return (
        <div className='containerGrid'>
            <Header logo={logo} />

            <section className='containerSection'>

                <HeaderDash />
                <div className='container'>
                    <CategoriasData />
                </div>
            </section>
        </div>
    )
}

